export default "__VITE_ASSET__2c5b7208__$_?react__"